module.exports = __webpack_public_path__ + "img/nav-settings.2d63dded.svg";